//Custom components

//Services
import { useDashboardData } from '@/hooks/ReactQueryHooks/useDashboardQuery';
//Assets and miscellaneous
import type { DashboardType } from '@/types/Analytics.ts';
import Card from '../../UI/Card/index.tsx';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

interface NewConstructionSummaryData {
  pipeline: number;
  hasNotBrokenGround: number;
  underConstruction: number;
  completed: number;
}

export default function NewConstructionSummary({ dashboard }: { dashboard: DashboardType }) {
  const fetchSourceSpentWidget = useDashboardData({
    dashboard,
    widget: Widget.NEW_CONSTRUCTION_SUMMARY,
  });
  const newConstructionSummaryData = fetchSourceSpentWidget?.data?.data as NewConstructionSummaryData | undefined;

  return (
    <>
      {newConstructionSummaryData && (
        <WidgetLayout dashboard={dashboard} widget={Widget.NEW_CONSTRUCTION_SUMMARY}>
          <Card title='New Construction Summary' error={fetchSourceSpentWidget.isError}>
            <div className='w-full h-full'>
              <table className='divide-y divide-gray-200 w-full'>
                <tbody className='bg-white divide-y divide-gray-200'>
                  <tr className='hover:bg-green-50 cursor-pointer'>
                    <th className='px-6 py-4 text-left text-xs font-bold text-neutralColor-normal capitalize tracking-wider'>
                      Pipeline (Units)
                    </th>
                    <td className='px-6 py-4'>{newConstructionSummaryData.pipeline ?? 0}</td>
                  </tr>
                  <tr className='hover:bg-green-50 cursor-pointer'>
                    <th className='px-6 py-4 text-left text-xs font-bold text-neutralColor-normal capitalize tracking-wider'>
                      has not broken ground (Units)
                    </th>
                    <td className='px-6 py-4'>{newConstructionSummaryData.hasNotBrokenGround ?? 0}</td>
                  </tr>
                  <tr className='hover:bg-green-50 cursor-pointer'>
                    <th className='px-6 py-4 text-left text-xs font-bold text-neutralColor-normal capitalize tracking-wider'>
                      has broken ground (Units)
                    </th>
                    <td className='px-6 py-4'>{newConstructionSummaryData.underConstruction ?? 0}</td>
                  </tr>
                  <tr className='hover:bg-green-50 cursor-pointer'>
                    <th className='px-6 py-4 text-left text-xs font-bold text-neutralColor-normal capitalize tracking-wider'>
                      {' '}
                      Completed (Units)
                    </th>
                    <td className='px-6 py-4'>{newConstructionSummaryData.completed ?? 0}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Card>
        </WidgetLayout>
      )}
    </>
  );
}
